(() => {
  const pushEvent = (event, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...detail });
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('variant-radios input[type="radio"]');
    if (!input) return;
    pushEvent('adenzo_variant_selected', {
      option: input.name,
      value: input.value,
    });
  });

  document.addEventListener('click', (event) => {
    const guideButton = event.target.closest('.product-popup-modal__opener button');
    if (guideButton) {
      const modal = document.querySelector(guideButton.closest('modal-opener').dataset.modal);
      pushEvent('adenzo_size_guide_opened', {
        has_content: Boolean(modal && !modal.querySelector('.size-guide-fallback')),
      });
    }

    const variantMatch = event.target.closest('[data-variant-match]');
    if (variantMatch && variantMatch.closest('a')) {
      const url = new URL(variantMatch.closest('a').href, window.location.origin);
      pushEvent('adenzo_variant_search_match_opened', {
        variant_id: url.searchParams.get('variant'),
      });
    }
  });
})();
